import { render, staticRenderFns } from "./MobileSideBar.vue?vue&type=template&id=424787bc&scoped=true&"
import script from "./MobileSideBar.vue?vue&type=script&lang=js&"
export * from "./MobileSideBar.vue?vue&type=script&lang=js&"
import style0 from "./MobileSideBar.vue?vue&type=style&index=0&id=424787bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424787bc",
  null
  
)

export default component.exports